import { useEffect } from 'react';

// NOTE: the `static-skeleton` id comes from app/views/layouts/_static_skeleton.html.erb. Call this
// only once something real is painted (the app shell, or a terminal error), never from a boot provider.
export function useRemoveStaticSkeleton() {
  useEffect(() => {
    document.getElementById('static-skeleton')?.remove();
  }, []);
}
